import { type AgentKind } from "../../agents/kindRegistry";
import { cliClientFor, cliCommand } from "./cliHandoff";

/* Shared by the three surfaces that hand off: /welcome, the Add-Agent modal and the
 * Reconnect drawer. Nothing is sent, so this is only the command string. */
export function cliHandoffCommand({
  agentId,
  userId,
  workspaceId,
  kind,
}: {
  agentId: string | null;
  /** Printed as `--user-id`, matching the snippet's x-ai21-user-id header. */
  userId?: string;
  /** Printed as `--workspace`, so the CLI creates its key where the reader is working. */
  workspaceId?: string;
  /** Names the `--client` to configure. Absent before the kind is chosen. */
  kind?: AgentKind;
}): string {
  if (agentId === null) return "";

  return cliCommand(agentId, {
    userId,
    workspaceId,
    client: kind === undefined ? undefined : cliClientFor(kind),
  });
}
